/**
 * @generated SignedSource<<f6be8816f0e078a42b8f843748f38b46>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesVersionRichTextSection_VersionRichTextSection">;
  readonly " $fragmentType": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection";
};
export type async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection$key = {
  readonly " $data"?: async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesVersionRichTextSection_AsyncVersionRichTextSection",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "ui_softwareReleasesVersionRichTextSection_VersionRichTextSection"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "d5a19fe58067365a8d3ea1743ac2c96d";

export default node;
